 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715":"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715","CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f":"CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f","CustomerProfile":"CustomerProfile","Newcustomer":"Newcustomer","driverProfile~newUsers~userProfile":"driverProfile~newUsers~userProfile","driverProfile":"driverProfile","newUsers":"newUsers","userProfile":"userProfile","settings":"settings","DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894":"DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894","DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0":"DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0","drivers":"drivers","myProfile":"myProfile","reservations":"reservations","DriverSchedule~driverSchedules~reservation":"DriverSchedule~driverSchedules~reservation","reservation":"reservation","VehicleDetails~area~newArea~newVehicle~rates":"VehicleDetails~area~newArea~newVehicle~rates","rates":"rates","destinations":"destinations","vehicles":"vehicles","area":"area","newArea":"newArea","DriverSchedule~driverSchedules":"DriverSchedule~driverSchedules","DriverSchedule":"DriverSchedule","driverSchedules":"driverSchedules","VehicleDetails":"VehicleDetails","newVehicle":"newVehicle","help":"help","helpDetails":"helpDetails","helpResults":"helpResults","driversAssign":"driversAssign","DestinationsRates":"DestinationsRates","areas":"areas","areasDestination":"areasDestination","customers":"customers","users":"users","authValidation":"authValidation","downloadFile":"downloadFile","forgotPassword~recoverPassword":"forgotPassword~recoverPassword","forgotPassword":"forgotPassword","recoverPassword":"recoverPassword","reservationConfirm":"reservationConfirm","reservationReject":"reservationReject","signin":"signin"}[chunkId]||chunkId) + "." + {"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715":"79116099","CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f":"8d3d3455","CustomerProfile":"64df8cc1","Newcustomer":"87f9afb5","driverProfile~newUsers~userProfile":"849e9fce","driverProfile":"11f4ae4b","newUsers":"89fb7e82","userProfile":"a442f747","settings":"f5c2c2ba","DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894":"34401c72","DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0":"6f51d3a8","drivers":"95605c76","myProfile":"dc90df32","reservations":"cfceb7af","DriverSchedule~driverSchedules~reservation":"ba034a8d","reservation":"4edad767","VehicleDetails~area~newArea~newVehicle~rates":"8b8c45b6","rates":"be95b9a7","destinations":"28ab22a9","vehicles":"4191add4","area":"7d972345","newArea":"453c87dc","DriverSchedule~driverSchedules":"f603d644","DriverSchedule":"2f026f15","driverSchedules":"8d03ad9b","VehicleDetails":"5a7c6522","newVehicle":"88eafaac","help":"872c60ec","helpDetails":"6c39d7a1","helpResults":"69b68bf7","driversAssign":"73e1be1c","DestinationsRates":"ce88ab00","areas":"6d1bda46","areasDestination":"dd46f9ef","customers":"fe3c16f5","users":"57945238","authValidation":"5c3eb027","downloadFile":"a89b270a","forgotPassword~recoverPassword":"f234e958","forgotPassword":"ed9142c0","recoverPassword":"3330c57d","reservationConfirm":"0441f146","reservationReject":"be159944","signin":"1dcf1a48"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894":1,"DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0":1,"reservations":1,"DriverSchedule~driverSchedules~reservation":1,"reservation":1,"VehicleDetails~area~newArea~newVehicle~rates":1,"rates":1,"area":1,"newArea":1,"DriverSchedule~driverSchedules":1,"DriverSchedule":1,"driverSchedules":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715":"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715","CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f":"CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f","CustomerProfile":"CustomerProfile","Newcustomer":"Newcustomer","driverProfile~newUsers~userProfile":"driverProfile~newUsers~userProfile","driverProfile":"driverProfile","newUsers":"newUsers","userProfile":"userProfile","settings":"settings","DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894":"DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894","DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0":"DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0","drivers":"drivers","myProfile":"myProfile","reservations":"reservations","DriverSchedule~driverSchedules~reservation":"DriverSchedule~driverSchedules~reservation","reservation":"reservation","VehicleDetails~area~newArea~newVehicle~rates":"VehicleDetails~area~newArea~newVehicle~rates","rates":"rates","destinations":"destinations","vehicles":"vehicles","area":"area","newArea":"newArea","DriverSchedule~driverSchedules":"DriverSchedule~driverSchedules","DriverSchedule":"DriverSchedule","driverSchedules":"driverSchedules","VehicleDetails":"VehicleDetails","newVehicle":"newVehicle","help":"help","helpDetails":"helpDetails","helpResults":"helpResults","driversAssign":"driversAssign","DestinationsRates":"DestinationsRates","areas":"areas","areasDestination":"areasDestination","customers":"customers","users":"users","authValidation":"authValidation","downloadFile":"downloadFile","forgotPassword~recoverPassword":"forgotPassword~recoverPassword","forgotPassword":"forgotPassword","recoverPassword":"recoverPassword","reservationConfirm":"reservationConfirm","reservationReject":"reservationReject","signin":"signin"}[chunkId]||chunkId) + "." + {"CustomerProfile~DriverSchedule~Newcustomer~VehicleDetails~area~destinations~driverProfile~driverSche~165fd715":"31d6cfe0","CustomerProfile~Newcustomer~driverProfile~drivers~driversAssign~myProfile~newUsers~reservation~reser~0277e53f":"31d6cfe0","CustomerProfile":"31d6cfe0","Newcustomer":"31d6cfe0","driverProfile~newUsers~userProfile":"31d6cfe0","driverProfile":"31d6cfe0","newUsers":"31d6cfe0","userProfile":"31d6cfe0","settings":"31d6cfe0","DestinationsRates~area~areas~areasDestination~customers~destinations~drivers~myProfile~newArea~rates~c7e14894":"a4bc13aa","DestinationsRates~areas~areasDestination~customers~destinations~drivers~myProfile~rates~reservations~a8401ed0":"4ad577e8","drivers":"31d6cfe0","myProfile":"31d6cfe0","reservations":"b95d10a8","DriverSchedule~driverSchedules~reservation":"8fea00dc","reservation":"5532e31a","VehicleDetails~area~newArea~newVehicle~rates":"7eb9b9fe","rates":"8f41bb59","destinations":"31d6cfe0","vehicles":"31d6cfe0","area":"989ee1bb","newArea":"989ee1bb","DriverSchedule~driverSchedules":"611a5b25","DriverSchedule":"f0172524","driverSchedules":"f0172524","VehicleDetails":"31d6cfe0","newVehicle":"31d6cfe0","help":"31d6cfe0","helpDetails":"31d6cfe0","helpResults":"31d6cfe0","driversAssign":"31d6cfe0","DestinationsRates":"31d6cfe0","areas":"31d6cfe0","areasDestination":"31d6cfe0","customers":"31d6cfe0","users":"31d6cfe0","authValidation":"31d6cfe0","downloadFile":"31d6cfe0","forgotPassword~recoverPassword":"31d6cfe0","forgotPassword":"31d6cfe0","recoverPassword":"31d6cfe0","reservationConfirm":"31d6cfe0","reservationReject":"31d6cfe0","signin":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
